module.exports = __webpack_public_path__ + "img/spyglass.e9d3aaaa.svg";